import { useBuildingTableStore } from '../filters.store';

export const useFilters = () => {
  const { handleToggleFiltersCard, appliedFiltersCount, isFiltersCardOpen } =
    useBuildingTableStore();

  return {
    handleToggleFiltersCard,
    isFiltersCardOpen,
    appliedFiltersCount,
  };
};
